
const DEFAULT_MESSAGE = {
    'code': 403, // 
    'type': 2,
    'message': '抱歉，您已无权限访问该页面。如有需要请您联系平台管理员',
    'target': `${ROUTER_PATH_PREFIX}/home`,
    'buttonLabel': '返回首页'
};


/**
 * 获取错误信息及返回地址
 * @returns {Object}
 */
function getErrorMsg(data) {
    let obj = { 
        ...DEFAULT_MESSAGE,
        message: '抱歉，您已无权限访问该页面。如有需要请您联系平台管理员！'
    };
    if(Object.prototype.toString.call(data) === '[object Object]') {
        // 只摘取code和message
        obj.code = data.code;
        obj.message = data.message;
    } else {
        obj.message = data || obj.message;
    }
    return obj;
}
export {
    getErrorMsg
};